import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { FaUser, FaGamepad, FaServer, FaEnvelope, FaCloud } from "react-icons/fa";
import service1 from "../assets/images/service1.jpg";
import service2 from "../assets/images/service2.jpg";
import service3 from "../assets/images/service3.jpg";
import service4 from "../assets/images/service4.jpg";
import service5 from "../assets/images/service5.jpg"; // Import your CSS file for styles

const Services = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(null);

  const services = [
    {
      title: t("services.profiles"),
      description: t("services.profiles_desc"),
      image: service1,
      link: "https://brt.iburtum.xyz",
      icon: <FaUser />,
    },
    {
      title: t("services.studio"),
      description: t("services.studio_desc"),
      image: service4,
      link: "https://studio.iburtum.xyz",
      icon: <FaGamepad />,
    },
    {
      title: t("services.hosting"),
      description: t("services.hosting_desc"),
      image: service3,
      icon: <FaServer />,
    },
    {
      title: t("services.mail"),
      description: t("services.mail_desc"),
      image: service5,
      icon: <FaEnvelope />,
    },
    {
      title: t("services.cloud"),
      description: t("services.cloud_desc"),
      image: service2,
      icon: <FaCloud />,
    },
  ];

  const handleServiceClick = (link) => {
    if (link) {
      setLoading(link);
      setTimeout(() => {
        window.open(link, "_blank");
        setLoading(null);
      }, 1000);
    }
  };

  return (
    <div className="container mx-auto p-4 sm:p-6 md:p-8">
      <motion.h1
        className="text-3xl sm:text-4xl font-bold text-center accent-text mb-8 sm:mb-12"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        id="services-title"
      >
        {t("services.title")}
      </motion.h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="glass p-4 sm:p-6 rounded-lg shadow-lg relative text-center card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            {loading === service.link && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-lg">
                <div className="loading-spinner"></div>
              </div>
            )}
            <img
              src={service.image}
              alt={service.title}
              className="service-image mb-4"
              onError={(e) => {
                console.error("Service image failed to load:", service.image);
                e.target.src = service1;
              }}
            />
            <div className="flex items-center justify-center mb-2">
              <span className="text-2xl mr-2 accent-text">{service.icon}</span>
              <h2 className="text-lg sm:text-xl font-semibold accent-text">{service.title}</h2>
            </div>
            <p className="text-sm sm:text-base mb-4">{service.description}</p>
            {service.link && (
              <button
                onClick={() => handleServiceClick(service.link)}
                className="bg-transparent border border-gray-500 accent-text hover:bg-gray-500 hover:text-white rounded px-4 py-2 transition-all text-sm sm:text-base"
              >
                {t("services.learn_more")}
              </button>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Services;